// @mui
import { Checkbox, Stack, StackProps, Typography } from "@mui/material";

// ----------------------------------------------------------------------

interface Props extends StackProps {
	action?: React.ReactNode;
	rowCount: number;
	numSelected: number;
	onSelectAllRows: (checked: boolean) => void;
}

export default function TableSelectedAction({
	action,
	rowCount,
	numSelected,
	onSelectAllRows,
	sx,
	...other
}: Props) {
	if (!numSelected) {
		return null;
	}

	return (
		<Stack
			direction='row'
			alignItems='center'
			sx={{
				px: 2,
				left: 0,
				width: 1,
				zIndex: 9,
				height: 38,
				position: "absolute",
				bgcolor: "primary.lighter",
				...sx
			}}
			{...other}
		>
			<Checkbox
				size='small'
				indeterminate={numSelected > 0 && numSelected < rowCount}
				checked={rowCount > 0 && numSelected === rowCount}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
					onSelectAllRows(event.target.checked)
				}
			/>

			<Typography
				variant='subtitle1'
				sx={{
					ml: 3,
					flexGrow: 1,
					color: "primary.main"
				}}
			>
				{numSelected} seleccionados
			</Typography>

			{action && action}
		</Stack>
	);
}
